import { ORDER_MODEL_CLASS_NAME } from 'models/daos/order/constants/index.cjs'
import getEndpointFromClassNameModelUtil from 'models/utils/get-endpoint-from-class-name'
import openSuccessBannerAction from 'modules/banner/actions/open-success'
import { emptyCartAction } from 'modules/cart/actions'
import { getValueCurrencySelector } from 'modules/currencies/selectors'
import { loadNotificationsAction } from 'modules/notifications/actions/load'
import {
  ORDERS_DOMAIN,
  ORDERS_PATH
} from 'modules/orders/constants/index.cjs'
import resetPromoCodeAction from 'modules/promo-codes/actions/reset'
import { getPromoCodeSelector } from 'modules/promo-codes/selectors'
import { createRemoteInstanceLegacyRedux } from 'modules/redux/actions/legacy/create'
import REDUX_OPTION from 'modules/redux/constants/option'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { saveSettingsAction } from 'modules/settings/actions'
import { getSelectedMethodCodeShippingSelector } from 'modules/shipping/selectors/get-selected-method'
import pushRouterAction from 'modules/router/actions/push'

function afterCreateOrderAction () {
  return dispatch => {
    dispatch(
      loadNotificationsAction(
        {
          [REDUX_OPTION.FORCED]: true,
          [REDUX_OPTION.RESETTING]: true
        })
    )

    dispatch(
      emptyCartAction()
    )

    dispatch(
      resetPromoCodeAction()
    )

    dispatch(
      pushRouterAction(ROUTE_PATH.ORDERS)
    )

    dispatch(
      openSuccessBannerAction('Your order was placed.')
    )

    dispatch(
      saveSettingsAction()
    )
  }
}

/**
 * Creates an Order with the given tokenId.
 * @private
 * @param  {Object} [data={}]
 *         {string} [tokenId]
 * @returns {Function}
 */
function createOrderAction (data = {}) {
  return (dispatch, getState) => {
    const promoCode = getPromoCodeSelector()(getState())
    return dispatch(
      createRemoteInstanceLegacyRedux(
        {
          endpoint: getEndpointFromClassNameModelUtil(ORDER_MODEL_CLASS_NAME),
          path: ORDERS_DOMAIN,
          className: ORDER_MODEL_CLASS_NAME,
          domainListPath: ORDERS_PATH.ALL,
          data: {
            ...data,
            currencyValue: getValueCurrencySelector()(getState()),
            shippingService: (
              getSelectedMethodCodeShippingSelector()(getState())
                .replace(/-/g, '.')
            ),
            promoCode: getValueReduxUtil(promoCode, 'name')
          }
        }))
      .then(order => {
        dispatch(
          afterCreateOrderAction(order)
        )
        return order
      })
  }
}

export {
  createOrderAction,
  afterCreateOrderAction
}
